/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Meeting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LiveAttendanceStatusType,
    LiveAttendanceStatusTypeFromJSON,
    LiveAttendanceStatusTypeFromJSONTyped,
    LiveAttendanceStatusTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface MeetingSessionSignalRequest
 */
export interface MeetingSessionSignalRequest {
    /**
     * 
     * @type {LiveAttendanceStatusType}
     * @memberof MeetingSessionSignalRequest
     */
    liveAttendanceStatusType: LiveAttendanceStatusType;
}

export function MeetingSessionSignalRequestFromJSON(json: any): MeetingSessionSignalRequest {
    return MeetingSessionSignalRequestFromJSONTyped(json, false);
}

export function MeetingSessionSignalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeetingSessionSignalRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'liveAttendanceStatusType': LiveAttendanceStatusTypeFromJSON(json['liveAttendanceStatusType']),
    };
}

export function MeetingSessionSignalRequestToJSON(value?: MeetingSessionSignalRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'liveAttendanceStatusType': LiveAttendanceStatusTypeToJSON(value.liveAttendanceStatusType),
    };
}


